export default class ArrayUtils {
	static shuffle(array) {
		let currentIndex = array.length, randomIndex;
		while (currentIndex !== 0) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex--;
			[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
		}
		return array;
	}

	static seededRandom(seed) {
		let s = seed;
		return () => {
			s = (s * 16807 + 0) % 2147483647;
			return (s - 1) / 2147483646;
		};
	}

	static seededShuffle(array, seed) {
		const rng = this.seededRandom(seed);
		const copy = [...array];
		let currentIndex = copy.length;
		while (currentIndex !== 0) {
			const randomIndex = Math.floor(rng() * currentIndex);
			currentIndex--;
			[copy[currentIndex], copy[randomIndex]] = [copy[randomIndex], copy[currentIndex]];
		}
		return copy;
	}
}
